import Vue from "vue";
import { operationService } from "../views/Operations/services/operation.service";
import { constants } from "@/shared/constants";
const state = {
  operations: {},
  operation: {},
  operationsCount: 0,
  applicationSector: {},
  applicationSectorType: {}
};

const getters = {
  getOperations: state => state.operations,
  getOperation: state => state.operation,
  getOperationsCount: state => state.operationsCount,
  getApplicationSector: state => state.applicationSector,
  getApplicationSectorType: state => state.applicationSectorType
};

const actions = {
  fetchOperationsAction(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search, tab }
  ) {
    return operationService
      .fetchOperations(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        tab
      )
      .then(result => {
        commit("setOperations", result);
      })
      .catch(error => {
        Vue.$log.error("fetchOperationsAction", error);
      });
  },
  fetchOperationsAgenceAction(
    { commit },
    {
      agenceId,
      currentPage,
      perPage,
      sortBy,
      sortDir,
      customFilter,
      search,
      tab
    }
  ) {
    return operationService
      .fetchOperationsAgence(
        agenceId,
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        tab
      )
      .then(result => {
        commit("setOperations", result);
      })
      .catch(error => {
        Vue.$log.error("fetchOperationsAction", error);
      });
  },
  getOperationsAdminAgence(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search, agenceId }
  ) {
    operationService
      .fetchOperationsAdminAgence(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        agenceId
      )
      .then(
        result => {
          commit("setOperations", result);
        },
        error => {
          Vue.$log.error("getOperationsAdminAgence", error);
        }
      );
  },

  getOperationsChargeDeProjet(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search }
  ) {
    operationService
      .fetchOperationsChargeDeProjet(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search
      )
      .then(
        result => {
          commit("setOperations", result);
        },
        error => {
          Vue.$log.error("getOperationsChargeDeProjet", error);
        }
      );
  },

  getOperationsChargeDeProjetById(
    { commit },
    { currentPage, perPage, sortBy, sortDir, customFilter, search, userId }
  ) {
    operationService
      .fetchOperationsChargeDeProjetById(
        currentPage,
        perPage,
        sortBy,
        sortDir,
        customFilter,
        search,
        userId
      )
      .then(
        result => {
          commit("setOperations", result);
        },
        error => {
          Vue.$log.error("getOperationsChargeDeProjetById", error);
        }
      );
  },

  getOperationByIdAction({ commit }, { idWork, idOperation }) {
    operationService.fetchWorkOperation(idWork, idOperation).then(
      result => {
        if (result) {
          commit("setOperation", result);
        } else {
          Vue.prototype.$notification.error("Opération non trouvée");
        }
      },
      error => {
        Vue.$log.error("getOperationByIdAction", error);
      }
    );
  },

  getOperationsCountAction({ commit }) {
    operationService.fetchOperationsCount().then(
      result => {
        commit("setOperationsCount", result);
      },
      error => {
        Vue.$log.error("getOperationsCountAction", error);
      }
    );
  },
  async getDetailOperationById({ commit }, { id }) {
    const op = await operationService.getDetailOperationById(id);
    if (!op) {
      Vue.prototype.$notification.error("Opération non trouvée");
      return;
    }
    commit("setOperation", op);

    const appSector =
      constants.APPLICATION_SECTORS.find(
        s => s.value === op.fiche.applicationSector
      ) || {};
    const sectorType =
      (appSector.types || []).find(t => t.value === op.fiche.type) || {};

    commit("setApplicationSector", appSector);
    commit("setApplicationSectorType", sectorType);
  }
};

const mutations = {
  setOperations(state, val) {
    state.operations = val;
  },
  setOperation(state, val) {
    state.operation = val;
  },
  setOperationsCount(state, val) {
    state.operationsCount = val;
  },
  setApplicationSector(state, val) {
    state.applicationSector = val;
  },
  setApplicationSectorType(state, val) {
    state.applicationSectorType = val;
  }
};

export const operation = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
